import { useLoaderData } from 'react-router';
import {
  CompanyInfoContainer,
  CompanyInfoSceneTab,
} from '../../../../../components/CompanyInfoScene/CompanyInfoScene.js';
import { InvitationList } from '../../../../../components/InvitationList/InvitationList.js';
import type { Invitation } from '../../../../../generated/api/invitation.js';

export const CompanyInfoInvitationsPath = () => {
  const invitations = useLoaderData() as Invitation[];

  return (
    <CompanyInfoContainer tab={CompanyInfoSceneTab.INVITATIONS}>
      <InvitationList invitations={invitations} />
    </CompanyInfoContainer>
  );
};
